import LoadingTab from '../LoadingTab';
import { useTeamMembersContext } from './Context/TeamMembersContext';
import TeamMembersActionBar from './TeamMembersActionBar/TeamMembersActionBar';
import TeamMembersTable from './TeamMembersTable/TeamMembersTable';

const TeamMemberTabContent = () => {
    const { isLoading, isTabLoadingError } = useTeamMembersContext();
    return (
        <LoadingTab isLoading={isLoading} loadingFailed={isTabLoadingError}>
            <TeamMembersActionBar />
            <TeamMembersTable />
        </LoadingTab>
    );
};

export default TeamMemberTabContent;
